import React from 'react'
import AddIcon from '@material-ui/icons/Add'
import ClearIcon from '@material-ui/icons/Clear'
import IconButton from '@material-ui/core/IconButton'
import { TrashIcon } from '@components/UI-Components/svg'
import * as css from './ClientDiscountActions.css'
import styled from 'styled-components'
import classNames from 'classnames'
import { EnhancedRestoreIcon } from '@core'
interface IClientDiscountAction {
  onDelete?: any
  onClear?: any
  onCreate?: any
  onRestore?: any
  isReadOnly?: boolean
  disabled?: boolean
  dontFreezeActionOnClick?: boolean
  isRowFreeze?: boolean
}
interface IStyledDiv {
  isRowFreeze: boolean
}
const StyledDiv = styled.div<IStyledDiv>(({ isRowFreeze }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  pointerEvents: isRowFreeze ? 'none' : 'auto',
  opacity: isRowFreeze ? 0.4 : 1
}))

export const ClientDiscountActions: React.FunctionComponent<IClientDiscountAction> =
  React.memo(
    ({
      onCreate,
      onClear,
      onDelete,
      onRestore,
      disabled,
      dontFreezeActionOnClick,
      isRowFreeze
    }) => {
      const [isDisabled, setDisable] = React.useState(false)
      const onDeleteClick = () => {
        setDisable(true)
        if (!isDisabled) {
          onDelete()
        }
      }
      return (
        <StyledDiv isRowFreeze={isRowFreeze as boolean} className={css.root}>
          {onClear ? (
            <IconButton
              disabled={disabled}
              classes={{
                root: css.iconButton
              }}
              onClick={onClear}
            >
              <ClearIcon />
            </IconButton>
          ) : null}
          {onDelete ? (
            <IconButton
              disabled={disabled || isDisabled}
              classes={{
                root: classNames(
                  disabled || isDisabled ? css.disabled : '',
                  css.iconButton
                )
              }}
              onClick={
                disabled ? null : dontFreezeActionOnClick ? onDelete : onDeleteClick
              }
            >
              <img src={TrashIcon} alt='' />
            </IconButton>
          ) : null}
          {onCreate ? (
            <IconButton
              disabled={disabled}
              classes={{
                root: css.iconButton
              }}
              onClick={onCreate}
            >
              <AddIcon />
            </IconButton>
          ) : null}
          {onRestore && (
            <IconButton
              disabled={disabled}
              classes={{
                root: css.iconButton
              }}
              onClick={() => onRestore(true)}
            >
              <EnhancedRestoreIcon />
            </IconButton>
          )}
        </StyledDiv>
      )
    }
  )
